export default function dateFormatter(date = "", withTime = false) {
    if (!date) return undefined;

    const newDate = new Date(date);
    if (withTime) {
        return newDate.toLocaleString('en-GB', {
            day: '2-digit',
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }
    const formattedDate = newDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: "short",
        year: "numeric"
    })
    return formattedDate;
}

